import { render, staticRenderFns } from "./OtpVerification.vue?vue&type=template&id=140997c2&scoped=true&"
import script from "./OtpVerification.vue?vue&type=script&lang=js&"
export * from "./OtpVerification.vue?vue&type=script&lang=js&"
import style0 from "./OtpVerification.vue?vue&type=style&index=0&id=140997c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140997c2",
  null
  
)

export default component.exports